/*
 * This project use mobile first integration
 * Default media is mobile
 */

const sizes = {
  mobile: 600,
  tablet: 750,
  desktop: 900,
  big: 1150,
  bigger: 1400,
  maxMockups: 1440,
  hd: 1900,
}

export default sizes
